import { ReactElement } from 'react';
import { Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { DialogConfigAndPreferencesProps } from './types';
import DialogConfigAndPreferencesSections from './Sections';
import {
  DialogConfigAndPreferencesContainer,
  DialogConfigAndPreferencesHeader,
  DialogConfigAndPreferencesHeaderCloseIcon,
  DialogConfigAndPreferencesContent,
} from './styles';

const DialogConfigAndPreferences = ({
  open,
  onClose,
}: DialogConfigAndPreferencesProps): ReactElement => (
  <DialogConfigAndPreferencesContainer open={open}>
    <DialogConfigAndPreferencesHeader>
      <Typography component="h2" variant="h6">
        Preferencias y Personalización
      </Typography>

      <DialogConfigAndPreferencesHeaderCloseIcon
        aria-label="close"
        onClick={onClose}
        size="small"
      >
        <CloseIcon />
      </DialogConfigAndPreferencesHeaderCloseIcon>
    </DialogConfigAndPreferencesHeader>

    <DialogConfigAndPreferencesContent dividers>
      <DialogConfigAndPreferencesSections />
    </DialogConfigAndPreferencesContent>
  </DialogConfigAndPreferencesContainer>
);

export default DialogConfigAndPreferences;
